import styled from "styled-components";
import {
	FONT_WT_MEDIUM,
	FONT_WT_LIGHT,
	COLOR_TEXT_PRIMARY_B2C,
	DESKTOP_SM_BP,
	MOBILE_L_BP,
	COLOR_DARK_GREEN_BUTTON,
} from "@website-builder/utilities-index";

export const CarouselContainer = styled.div`
	padding: 60px 80px 80px 80px;
	display: flex;

	.content {
		width: 50%;
		padding-right: 20px;
	}

	.heading {
		font-size: 28px;
		font-weight: ${FONT_WT_MEDIUM};
		color: ${COLOR_TEXT_PRIMARY_B2C};
		margin-top: 20px;
		margin-bottom: 25px;
	}

	.description {
		font-size: 16px;
		font-weight: ${FONT_WT_LIGHT};
		line-height: 1.69;
		color: ${COLOR_TEXT_PRIMARY_B2C};
	}

	.imageContainer {
		width: 50%;
	}

	.mobileHeading {
		display: none;
	}

	.slick-slide img {
		display: inherit;
	}
	.slick-dots {
		margin-top: 15px;
		bottom: -40px;
	}
	.slick-dots li {
		margin: 0px;
	}
	.slick-dots li.slick-active button:before {
		color: ${COLOR_DARK_GREEN_BUTTON};
	}
	.slick-dots li button:before {
		font-size: 15px;
		color: ${COLOR_DARK_GREEN_BUTTON};
	}
	.slick-track {
		div {
			div {
				display: flex !important;
				justify-content: center;
				img {
					width: 80% !important;
				}
			}
		}
	}
	.slick-next {
		right: 10px !important;
	}

	@media only screen and (max-width: ${DESKTOP_SM_BP}px) {
		.heading {
			margin-top: 0px;
		}
		.imageContainer {
			margin-top: 50px;
		}
	}

	@media only screen and (max-width: ${MOBILE_L_BP}px) {
		padding: 20px 20px;
		flex-direction: column-reverse;
		.content {
			width: 100%;
			padding-right: 0px;
			margin-top: 20px;
		}
		.imageContainer {
			width: 100%;
			margin-top: 15px;
			margin-bottom: 20px;
		}
		.mobileHeading {
			display: block;
			text-align: center;
			color: ${COLOR_TEXT_PRIMARY_B2C};
			font-size: 24px;
			font-weight: ${FONT_WT_MEDIUM};
			line-height: 1.17;
			margin-top: 30px;
			margin-bottom: 14px;
		}
		.heading {
			display: none;
		}
	}
`;
